import template from "./bBillingTypeTable.html";

export function bBillingTypeTableDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bBillingTypeTableController,
    controllerAs: 'bBillingTypeTable',
    bindToController: true,
    scope: {
      billingTypesList: "=",
      user: "=",
      state: "=",
      stateHandler: "&",
      refreshHandler: "&",
      postNoteHandler: "&",
      doesBillingTypeIsDefault: "&"
    }
  };

  return directive;
}

class bBillingTypeTableController {
  constructor($routeParams, Admin, bModal) {
    'ngInject';

    this.$routeParams = $routeParams;

    this.Admin = Admin;

    this.bModal = bModal;

    this.billingTypeFields = {
      billingType: "info",
      country: "info"
    };

    this.billingTypeGlobalActions = [
      {
        name: 'add_new',
        functionName: 'showAddNewModal',
        fa: "fa-plus"
      }
    ];

    this.billingTypeRowActions = [
      {
        name: 'edit',
        functionName: 'showEditModal'
      },
      {
        name: 'delete',
        functionName: 'showDeleteModal'
      }
    ];

    this.newBillingTypeData = {
      name: {
        type: 'text'
      },
      country: {
        type: 'text',
        editionDisabled: true
      }
    };

    this.billingTypeData = {
      name: {
        type: 'text'
      },
      country: {
        type: 'text',
        editionDisabled: true
      }
    };

    this.deleteBillingTypeData = {
      name: {
        type: 'text',
        editionDisabled: true
      },
      country: {
        type: 'text',
        editionDisabled: true
      }
    };
  }

  showAddNewModal() {
    this.billingTypeModalVisible = true;
    this.billingTypeModalState = 'new';
    this.dialogTitle = "NEW_BILLING_TYPE";
    this.billingTypeValues = {
      country: this.$routeParams.name
    };
  }

  async billingTypeModalSubmit(values) {
    if (this.state === 'loading')
      return;

    this.stateHandler()('loading');
    let response;

    switch(this.billingTypeModalState) {
      case 'new':
        response = this.Admin.createCountryBillingType(values.country, values.name);
        break;
      case 'edit':
        response = this.Admin.updateCountryBillingType(values.country, values.id, values.name);
        break;
      case 'delete':
        if (this.doesBillingTypeIsDefault()(values)) {
          this.modalConfig = {
            cancelText: 'No',
            acceptText: 'Yes'
          };
          this.closeModal();
          await this.bModal.show(this.modalConfig).then(() => {
            response = this.Admin.deleteCountryBillingType(values.country, values.id);
          }, () => this.stateHandler()('loaded'));
        } else {
          response = this.Admin.deleteCountryBillingType(values.country, values.id);
        }
        break;
    }

    response
      .then(() => {
        this.stateHandler()('loaded');
        this.refreshHandler()();
        this.closeModal();
      }, (error) => {
        this.stateHandler()('error');
        const worklogDefinedRegex = /Worklog with billing type [A-Za-z0-9-]+ is defined/g;
        let errorMessage = null;

        if (worklogDefinedRegex.test(error.data.message))
          errorMessage = 'There is a worklog with this billing type';

        this.postNoteHandler()({
          type: "error",
          error: {
            ...error,
            data: {
              ...error.data,
              message: errorMessage || error.data.message
            }
          }
        });
      });
  }

  showEditModal(values) {
    this.billingTypeModalVisible = true;
    this.billingTypeModalState = 'edit';
    this.dialogTitle = "EDIT_BILLING_TYPE";
    this.billingTypeValues = {...values};
  }

  showDeleteModal(values) {
    this.billingTypeModalVisible = true;
    this.billingTypeModalState = 'delete';
    this.dialogTitle = "DELETE_BILLING_TYPE";
    this.billingTypeValues = {...values};
  }

  closeModal() {
    this.billingTypeModalVisible = false;
    this.billingTypeModalState = null;
    this.dialogTitle = null;
  }
}